/**
 * LP workbench (slate / production) UI strings.
 * Use: t('lpWorkbench.someKey')
 */

export const lpWorkbenchEn = {
  brand: 'GLOBAL MOBILITY',
  brandTitle: 'Global Mobility',
  workspaceEyebrow: 'Workspace',
  productions: 'Productions',
  lineProducerRole: 'Line Producer',
  slate: 'Slate',
  addProduction: 'Add production',
  newProduction: 'New production',
  newProductionButton: '＋ New production',
  demoTools: 'Demo tools',
  newDemo: 'New demo',
  newDemoButton: '+ New demo',
  createDemo: 'Create demo',
  creatingDemo: 'Creating…',
  productionName: 'Production name',
  demoCountry: 'Country',
  createDemoFailed: 'Could not create the demo. Please try again.',
  profile: 'Profile',
  deleteProduction: 'Delete production',
  logOut: 'Log out',
  signOut: 'Sign out',
  account: 'Account',
  close: 'Close',
  cancel: 'Cancel',
  delete: 'Delete',
  deleting: 'Deleting…',
  deleteProductionTitle: 'Delete production',
  deleteProductionBody:
    'Delete <b>{{name}}</b>? This permanently removes the production, its crew list, and participant accounts/data. This cannot be undone.',
  deleteProductionFailed: 'Could not delete this production.',
  thisProduction: 'this production',

  loadingProductions: 'Opening your slate…',
  loading: 'LOADING',
  addFirstProject: 'Add your first project',
  addFirstProjectHint: 'Upload a cast & crew schedule to get started',
  loadProductionsError: 'Could not load productions. Please refresh the page.',
  retry: 'Retry',
  participants: 'Participants',
  country: 'Country',
  needsAttention: 'Needs attention',
  startDemo: 'Start demo',
  restartDemoCard: 'Restart demo',
  openProduction: 'Open',
  backToProductions: '< Productions',
  demoScenario: 'Demo scenario',
  startProductionTitle: 'Start {{name}}',
  yourName: 'Your name',
  yourEmail: 'Your email',
  audienceEmails: 'Audience emails',
  addAudienceEmail: '+ Add audience email',
  removeAudienceEmail: 'Remove audience email',
  audienceEmailInvalid: 'Enter a valid audience email.',
  startDemoAction: 'Start',
  restartDemo: 'Restart',
  joinLinkForRun: 'Join link for this run',
  copyJoinLink: 'Copy',
  joinLinkCopied: 'Copied',
  sendInvitationAndStart: 'Send invitation & start',
  startingDemo: 'Starting…',
  noJoinLinkYet: 'Join link will appear after the production is ready.',

  addParticipants: 'Add participants',
  name: 'Name',
  email: 'Email',
  phoneOptional: 'Phone (optional)',
  roleOptional: 'Role (optional)',
  comingFrom: 'Coming from',
  fullNamePlaceholder: 'Full name',
  addAnotherParticipant: 'Add another participant',
  removeParticipant: 'Remove participant',
  skip: 'Skip',
  save: 'Save',
  saving: 'Saving…',
  selectCountry: 'Select country…',
  loadingCountries: 'Loading countries…',
  addParticipantEmailOrSkip: 'Add at least one participant with an email, or click Skip.',
  nameRequiredEach: 'Name is required for each participant.',
  chooseComingFrom: 'Choose where each participant is coming from.',
  startDemoTimeout:
    'Start Demo is still working on a large roster — wait a moment and try again, or use Reset in Demo tools first.',
  startDemoFailed: 'Could not start the demo. Please try again.',

  tabOverview: 'Overview',
  tabMobility: 'Mobility',
  tabProduction: 'Production',
  tabTasks: 'Tasks',
  subImmigration: 'Immigration',
  subTax: 'Tax',
  subSocial: 'Social Security',
  subEquipment: 'Equipment',
  subRoster: 'Roster',
  subBudget: 'Budget',
  subSchedule: 'Schedule',

  tasks: 'Tasks',
  addWidget: 'Add widget',
  savingWidget: 'Saving...',
  allWidgetsAdded: 'All widgets added',
  noRequestsYet: 'No requests in progress yet.',
  status: 'Status',
  complete: 'Complete',
  outstanding: 'outstanding',
  due: 'Due',
  lastReminder: 'Last reminder',
  notRegistered: 'Not registered',
  notRegisteredSub: 'These people have not registered yet. Copy the list to follow up.',

  loadingProduction: 'Loading production…',
  loadProductionError: 'Could not load this production.',
  travelItinerary: 'Travel itinerary',
  sendDocument: 'Send a document',
  reviewDocument: 'Review a document',
  customRequest: 'Custom',
};

export const lpWorkbenchEs = {
  brand: 'GLOBAL MOBILITY',
  brandTitle: 'Global Mobility',
  workspaceEyebrow: 'Espacio de trabajo',
  productions: 'Producciones',
  lineProducerRole: 'Line Producer',
  slate: 'Pizarra',
  addProduction: 'Añadir producción',
  newProduction: 'Nueva producción',
  newProductionButton: '＋ Nueva producción',
  demoTools: 'Herramientas demo',
  newDemo: 'Nueva demo',
  newDemoButton: '+ Nueva demo',
  createDemo: 'Crear demo',
  creatingDemo: 'Creando…',
  productionName: 'Nombre de la producción',
  demoCountry: 'País',
  createDemoFailed: 'No se pudo crear la demo. Inténtalo de nuevo.',
  profile: 'Perfil',
  deleteProduction: 'Eliminar producción',
  logOut: 'Cerrar sesión',
  signOut: 'Cerrar sesión',
  account: 'Cuenta',
  close: 'Cerrar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  deleting: 'Eliminando…',
  deleteProductionTitle: 'Eliminar producción',
  deleteProductionBody:
    '¿Eliminar <b>{{name}}</b>? Esto elimina de forma permanente la producción, su lista de equipo y las cuentas/datos de los participantes. No se puede deshacer.',
  deleteProductionFailed: 'No se pudo eliminar esta producción.',
  thisProduction: 'esta producción',

  loadingProductions: 'Abriendo tu pizarra…',
  loading: 'CARGANDO',
  addFirstProject: 'Añade tu primer proyecto',
  addFirstProjectHint: 'Sube un calendario de elenco y equipo para empezar',
  loadProductionsError: 'No se pudieron cargar las producciones. Actualiza la página.',
  retry: 'Reintentar',
  participants: 'Participantes',
  country: 'País',
  needsAttention: 'Requieren atención',
  startDemo: 'Iniciar demo',
  restartDemoCard: 'Reiniciar demo',
  openProduction: 'Abrir',
  backToProductions: '< Producciones',
  demoScenario: 'Escenario demo',
  startProductionTitle: 'Iniciar {{name}}',
  yourName: 'Tu nombre',
  yourEmail: 'Tu correo',
  audienceEmails: 'Correos de la audiencia',
  addAudienceEmail: '+ Añadir correo de audiencia',
  removeAudienceEmail: 'Quitar correo de audiencia',
  audienceEmailInvalid: 'Introduce un correo de audiencia válido.',
  startDemoAction: 'Iniciar',
  restartDemo: 'Reiniciar',
  joinLinkForRun: 'Enlace de acceso para esta ejecución',
  copyJoinLink: 'Copiar',
  joinLinkCopied: 'Copiado',
  sendInvitationAndStart: 'Enviar invitación e iniciar',
  startingDemo: 'Iniciando…',
  noJoinLinkYet: 'El enlace aparecerá cuando la producción esté lista.',

  addParticipants: 'Añadir participantes',
  name: 'Nombre',
  email: 'Correo',
  phoneOptional: 'Teléfono (opcional)',
  roleOptional: 'Rol (opcional)',
  comingFrom: 'Procedencia',
  fullNamePlaceholder: 'Nombre completo',
  addAnotherParticipant: 'Añadir otro participante',
  removeParticipant: 'Quitar participante',
  skip: 'Omitir',
  save: 'Guardar',
  saving: 'Guardando…',
  selectCountry: 'Seleccionar país…',
  loadingCountries: 'Cargando países…',
  addParticipantEmailOrSkip: 'Añade al menos un participante con correo, o pulsa Omitir.',
  nameRequiredEach: 'El nombre es obligatorio para cada participante.',
  chooseComingFrom: 'Elige de dónde viene cada participante.',
  startDemoTimeout:
    'Iniciar demo sigue procesando un elenco grande — espera un momento e inténtalo de nuevo, o usa Restablecer en Herramientas demo primero.',
  startDemoFailed: 'No se pudo iniciar la demo. Inténtalo de nuevo.',

  tabOverview: 'Resumen',
  tabMobility: 'Movilidad',
  tabProduction: 'Producción',
  tabTasks: 'Tareas',
  subImmigration: 'Inmigración',
  subTax: 'Impuestos',
  subSocial: 'Seguridad Social',
  subEquipment: 'Equipo',
  subRoster: 'Elenco',
  subBudget: 'Presupuesto',
  subSchedule: 'Calendario',

  tasks: 'Tareas',
  addWidget: 'Añadir widget',
  savingWidget: 'Guardando...',
  allWidgetsAdded: 'Todos los widgets añadidos',
  noRequestsYet: 'Aún no hay solicitudes en curso.',
  status: 'Estado',
  complete: 'Completo',
  outstanding: 'pendientes',
  due: 'Vence',
  lastReminder: 'Último recordatorio',
  notRegistered: 'No registrados',
  notRegisteredSub: 'Estas personas aún no se han registrado. Copia la lista para hacer seguimiento.',

  loadingProduction: 'Cargando producción…',
  loadProductionError: 'No se pudo cargar esta producción.',
  travelItinerary: 'Itinerario de viaje',
  sendDocument: 'Enviar un documento',
  reviewDocument: 'Revisar un documento',
  customRequest: 'Personalizado',
};
